import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
  FieldWrapper,
  FormlyFieldConfig,
  FormlyFieldProps,
} from '@ngx-formly/core';
import { Avatar } from 'primeng/avatar';
import { Divider } from 'primeng/divider';
import { FORM_IMPORTS } from '../../_shared/_imports/form.import';

export interface CheckboxFieldProps extends FormlyFieldProps {
  type?: 'inline' | 'divided' | 'icon';
  reverse?: boolean;
  icon?: string;
  divider?: boolean;
  fullWidth?: boolean;
}

@Component({
  selector: 'formly-wrapper-primeng-checkbox',
  standalone: true,
  imports: [CommonModule, ...FORM_IMPORTS, Divider, Avatar],
  template: `
    @if (props.hidden) {
    } @else {
      @switch (props.type) {
        @case ('icon') {
          <div class="p-field flex flex-col justify-items-center items-center">
            <div>
              <p-avatar
                [icon]="props.icon"
                severity="accent"
                size="xlarge"
                shape="circle"
              />
            </div>
            <div class="mb-2 -mt-[calc(var(--p-avatar-lg-icon-size)/2)]">
              <label
                [for]="id"
                class="{{
                  showError
                    ? 'text-(--p-form-field-invalid-placeholder-color)'
                    : ''
                }}"
                [innerHTML]="props.label"
              ></label>
            </div>
            <ng-container #fieldComponent></ng-container>
          </div>
        }
        @case ('divided') {
          <div class="p-field">
            <div
              class="flex gap-4 items-center w-[calc(100%-var(--p-toggleswitch-width)-0.5rem)]"
            >
              @if (props.icon) {
                <div class="flex gap-2 items-center">
                  <div>
                    <p-avatar
                      [icon]="props.icon"
                      severity="accent"
                      size="xlarge"
                      shape="circle"
                    />
                  </div>
                  <div class="flex flex-col gap-2">
                    <div
                      class="font-bold {{
                        showError
                          ? 'text-(--p-form-field-invalid-placeholder-color)'
                          : ''
                      }}"
                      [innerHTML]="props.label"
                    ></div>
                    <div class="text-sm" [innerHTML]="props.description"></div>
                  </div>
                </div>
              } @else {
                <div
                  class="{{
                    showError
                      ? 'text-(--p-form-field-invalid-placeholder-color)'
                      : ''
                  }}"
                  [innerHTML]="props.label"
                ></div>
              }
            </div>
            <div class="flex {{ props.fullWidth !== false ? 'justify-between' : '' }} content-center gap-2">
              @if (props.divider ?? true) {
                <p-divider></p-divider>
              } @else {
                <div></div>
              }
              <ng-container #fieldComponent></ng-container>
            </div>
            @if (showError) {
              <small
                class="text-(--p-form-field-invalid-placeholder-color) italic ml-(--p-inputtext-padding-x)"
              >
                <formly-validation-message
                  class="ui-message-text"
                  [field]="field"
                ></formly-validation-message>
              </small>
            }
          </div>
        }
        @default {
          <div class="p-field">
            <div
              class="flex gap-2 items-center {{ props.fullWidth !== false ? 'justify-between' : '' }}"
            >
              @if (props.reverse) {
                <ng-container #fieldComponent></ng-container>
              }
              @if (props.icon) {
                <div class="flex gap-4">
                  <span class="{{ props.icon }} text-4xl text-primary"></span>
                  <div class="flex flex-col">
                    <div
                      class="{{
                        showError
                          ? 'text-(--p-form-field-invalid-placeholder-color)'
                          : ''
                      }} {{ props.description ? 'font-bold' : '' }}"
                      [innerHTML]="props.label"
                    ></div>
                    <div class="text-sm" [innerHTML]="props.description"></div>
                  </div>
                </div>
              } @else {
                <div class="flex flex-col">
                  <div
                    class="{{
                      showError
                        ? 'text-(--p-form-field-invalid-placeholder-color)'
                        : ''
                    }}"
                    [innerHTML]="props.label"
                  ></div>
                  <div class="text-sm" [innerHTML]="props.description"></div>
                </div>
              }
              @if (!props.reverse) {
                <ng-container #fieldComponent></ng-container>
              }
            </div>
            @if (showError) {
              <small
                class="text-(--p-form-field-invalid-placeholder-color) italic ml-(--p-inputtext-padding-x)"
              >
                <formly-validation-message
                  class="ui-message-text"
                  [field]="field"
                ></formly-validation-message>
              </small>
            }
          </div>
        }
      }
    }
  `,
})
export class CheckboxFormlyWrapper extends FieldWrapper<
  FormlyFieldConfig<CheckboxFieldProps>
> {}
